import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { WebhookDelivery } from "types/generated";

const WebhookDeliveriesTableDropdownCell = ({
  ...cellProps
}: TableSimpleCellProps<WebhookDelivery>) => {
  return <TableSimpleCell {...cellProps} />;
};

export default WebhookDeliveriesTableDropdownCell;
